import { Routes } from '@angular/router';
import { ForgotPasswordNotificationComponent } from './forgot-password-notification/forgot-password-notification.component';
import { PhoneSendNotificationComponent } from './phone-send-notification/phone-send-notification.component';
import { AccountSuspensionComponent } from './account-suspension/account-suspension.component';

export const notificationRoutes: Routes = [
  {
    path: '',
    redirectTo: '/result/page-not-found',
    pathMatch: 'full'
  },
  {
    path: 'forgot-password/:trackingId',
    component: ForgotPasswordNotificationComponent
  },
  {
    path: 'phone-send/:trackingId',
    component: PhoneSendNotificationComponent
  },
  {
    path: 'account-suspension/:trackingId',
    component: AccountSuspensionComponent
  },
  {
    path: '**',
    redirectTo: '/result/page-not-found',
    pathMatch: 'full'
  }
];
